import { MemorySessionStorage } from "./MemorySessionStorage";
var Session = /** @class */ (function () {
    function Session(category, sessionStorageFactory, component) {
        this.category = category;
        if (!sessionStorageFactory) {
            sessionStorageFactory = function (category) { return new MemorySessionStorage(category); };
        }
        Session.storage = Session.storage || sessionStorageFactory(this.category);
        if (component != null) {
            this.attach(component);
        }
    }
    Session.prototype.attach = function (component) {
        Session.callbacks[this.category] = Session.callbacks[this.category] || $.Callbacks();
        Session.callbacks[this.category].add(component.fireHandler.bind(component, 'change.session'));
    };
    Session.prototype.getAll = function () {
        return Session.storage.getAll();
    };
    Session.prototype.get = function (key) {
        return Session.storage.getItem(key);
    };
    Session.prototype.getStorage = function () {
        return Session.storage;
    };
    Session.prototype.set = function (key, value) {
        Session.storage.setItem(key, value);
        this.changed(key, value);
    };
    Session.prototype.remove = function (key) {
        Session.storage.removeItem(key);
        this.changed(key, null);
    };
    Session.prototype.changed = function (key, value) {
        Session.callbacks[this.category].fire(key, value);
    };
    Session.callbacks = {};
    return Session;
}());
export { Session };
//# sourceMappingURL=Session.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/data/Session.js
// module id = 38
// module chunks = 1